"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var WidgetMenuButton_1 = __importDefault(require("../../WidgetMenuButton"));
var Button_1 = require("ContentTokens/Models/Button");
var ButtonWidget_1 = require("../ButtonWidget");
var ButtonWidgetStylePanel_1 = __importDefault(require("../ButtonWidgetStylePanel"));
var ReactCSSTransitionGroup = require("react-addons-css-transition-group");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ButtonWidgetLinkMenu_1 = __importDefault(require("Project/QwilrEditor/Widgets/ButtonWidget/ButtonWidgetMenu/ButtonWidgetLinkMenu"));
var URL_1 = require("@CommonFrontendBackend/Utils/URL");
var CorrectLink_1 = __importDefault(require("@CommonFrontendBackend/Utils/CorrectLink"));
var ButtonWidgetMenu = (function (_super) {
    __extends(ButtonWidgetMenu, _super);
    function ButtonWidgetMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.isContextualStylesOpen = false;
        _this.isHrefValid = true;
        _this.updateLink = function (href) {
            if (href && !(0, URL_1.isURL)((0, CorrectLink_1.default)(href), true)) {
                _this.isHrefValid = false;
            }
            else {
                _this.isHrefValid = true;
                _this.props.update({ href: href });
                _this.props.telemetry.buttonUrlEdited(href);
            }
        };
        _this.updateToken = function (href) {
            _this.props.update({ href: href });
            _this.props.telemetry.buttonCustomTokenUpdated(href);
        };
        _this.removeToken = function () {
            _this.props.update({ href: undefined });
        };
        _this.toggleContextualStyles = function () {
            _this.isContextualStylesOpen = !_this.isContextualStylesOpen;
        };
        _this.openLinkEditor = function () {
            _this.props.onChangeMenuState(ButtonWidget_1.ButtonWidgetMenuState.LinkEdit);
        };
        _this.closeLinkEditor = function () {
            if (_this.isHrefValid) {
                _this.props.onChangeMenuState(ButtonWidget_1.ButtonWidgetMenuState.Toolbar);
            }
        };
        return _this;
    }
    ButtonWidgetMenu.prototype.componentDidUpdate = function () {
        if (!this.props.showMenu && this.isContextualStylesOpen) {
            this.isContextualStylesOpen = false;
        }
    };
    ButtonWidgetMenu.prototype.render = function () {
        if (!this.props.showMenu) {
            return react_1.default.createElement("div", null);
        }
        return (react_1.default.createElement("div", { className: "button-widget__menu-wrapper editor-toolbar" },
            this.renderMenu(),
            react_1.default.createElement("div", { className: "button-widget__hover-bridge" })));
    };
    ButtonWidgetMenu.prototype.renderMenu = function () {
        switch (this.props.menuState) {
            case ButtonWidget_1.ButtonWidgetMenuState.LinkEdit:
                return this.renderLinkEditor();
            case ButtonWidget_1.ButtonWidgetMenuState.Toolbar:
                return this.renderMenuButtons();
            case ButtonWidget_1.ButtonWidgetMenuState.None:
                return react_1.default.createElement(react_1.default.Fragment, null);
        }
    };
    ButtonWidgetMenu.prototype.renderMenuButtons = function () {
        var _a = this.props, href = _a.href, deleteWidget = _a.deleteWidget, updateAlignment = _a.updateAlignment, blockStore = _a.blockStore, brandStore = _a.brandStore, reselectText = _a.reselectText;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(WidgetMenuButton_1.default, { icon: react_1.default.createElement(icons_1.AlignLeft, null), onMouseDown: function () { return updateAlignment(Button_1.ButtonWidgetAlignment.Left); } }),
            react_1.default.createElement(WidgetMenuButton_1.default, { icon: react_1.default.createElement(icons_1.AlignCenter, null), onMouseDown: function () { return updateAlignment(Button_1.ButtonWidgetAlignment.Center); } }),
            react_1.default.createElement(WidgetMenuButton_1.default, { icon: react_1.default.createElement(icons_1.Link, null), customClass: href ? "button-widget__toolbar--link-highlight" : "", onMouseDown: this.openLinkEditor }),
            react_1.default.createElement(WidgetMenuButton_1.default, { icon: react_1.default.createElement(icons_1.Styles, null), onMouseDown: this.toggleContextualStyles }),
            react_1.default.createElement(WidgetMenuButton_1.default, { icon: react_1.default.createElement(icons_1.Delete, null), onMouseDown: deleteWidget, isDestructive: true }),
            react_1.default.createElement("div", { className: "contextual-table-style", style: { left: "232px", top: "-1px" }, onMouseDown: function (event) { return event.stopPropagation(); }, contentEditable: false },
                react_1.default.createElement(ReactCSSTransitionGroup, { transitionName: "fade", transitionEnterTimeout: 150, transitionLeaveTimeout: 150 }, this.isContextualStylesOpen && (react_1.default.createElement(ButtonWidgetStylePanel_1.default, { blockStore: blockStore, brandStore: brandStore, reselectText: reselectText }))))));
    };
    ButtonWidgetMenu.prototype.renderLinkEditor = function () {
        return (react_1.default.createElement("div", { className: "button-widget__menu-link-edit", "data-slate-editor": true },
            react_1.default.createElement(ButtonWidgetLinkMenu_1.default, { updateLink: this.updateLink, href: this.props.href, open: this.openLinkEditor, close: this.closeLinkEditor, confirmToken: this.updateToken, removeToken: this.removeToken, tokensEnabled: this.props.tokensEnabled, hasError: !this.isHrefValid })));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ButtonWidgetMenu.prototype, "isContextualStylesOpen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ButtonWidgetMenu.prototype, "isHrefValid", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ButtonWidgetMenu.prototype, "updateLink", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ButtonWidgetMenu.prototype, "toggleContextualStyles", void 0);
    ButtonWidgetMenu = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ButtonWidgetMenu);
    return ButtonWidgetMenu;
}(react_1.default.Component));
exports.default = ButtonWidgetMenu;
